import { createStore, combineReducers, applyMiddleware, compose } from 'redux';

//Reducer
import userStatus from '../reducers/userStatus'
import passwordData from '../reducers/passwordData'
import userData from '../reducers/userData'
import searchPassword from '../reducers/searchData'

import thunk from 'redux-thunk';


const reducers = combineReducers({
   userData: userData,
   userStatus: userStatus,
   passwordData: passwordData,
   searchPassword: searchPassword
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));

export default store;